import type { ReactNode } from "react";
import { Text } from "@volca/ui/components/ui/text";
export const ExampleNote = ({ children }: { children: ReactNode }) => (
  <Text tone="muted" role="status" className="px-4 py-3 leading-relaxed">
    {children}
  </Text>
);
